import { type FC, memo } from "react";
import LanguageAwareExternalContent from "../Configurators/Linear/components/LanguageAwareExternalContent";
import instance from "../utils/i18n";
import { Trans, useTranslation } from "react-i18next";
import { type TranslationModel, TranslationType } from "~/common/TranslationModel";

type Props = TranslationModel;

export const Translation = memo(((translation: Props) => {
  const { t } = useTranslation();
  if (!translation.value) {
    return null;
  }

  switch (translation.type) {
    case TranslationType.RAW_TEXT: {
      const label = t(translation.value);
      return <span dangerouslySetInnerHTML={{ __html: label }} />;
    }

    case TranslationType.INTERNAL: {
      return <Trans i18nKey={translation.value} values={translation.params} />;
    }

    case TranslationType.EXTERNAL: {
      return <LanguageAwareExternalContent content={translation.value} loadedClassname={"scha__lc__external-label"} />;
    }

    default:
      throw new Error("Not implemented!");
  }
}) as FC<Props>);

export const resolveTranslationSync = (translation: TranslationModel): string => {
  switch (translation.type) {
    case TranslationType.RAW_TEXT: {
      return translation.value;
    }

    case TranslationType.INTERNAL: {
      if (translation.params) {
        return instance.t(translation.value, translation.params);
      } else {
        return instance.t(translation.value);
      }
    }

    case TranslationType.EXTERNAL: {
      throw new Error("Not implemented!");
    }

    default:
      throw new Error("Not implemented!");
  }
};
